import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { find } from 'lodash';
import momentTz from 'moment-timezone';
import {
  getCalendarState,
  MarketDrawerRootReducerState
} from '../../../../state/reducer';
import { CalendarState } from '../../../../state/calendar/reducer';
import { Event } from '../../../../models/calendar';
import { DEFAULT_TIMEZONE } from '../../../../services/calendar.service';

@Component({
  selector: 'muni-gameday-market-drawer-calendar-header',
  templateUrl: './calendar-header.template.html',
  styleUrls: ['./calendar-header.styles.scss']
})
export class CalendarHeaderComponent {
  public readonly calendarState: Observable<CalendarState> = this.store.pipe(
    select(getCalendarState)
  );
  public readonly eventToShow: Observable<Event> = this.calendarState.pipe(
    map(s => {
      return (
        find(s.events, e => e.id === s.mostRecentEventId) ||
        find(s.events, e => !e.nonTimed)
      );
    })
  );
  public readonly unseen: Observable<boolean> = this.calendarState.pipe(
    map(s => s.unseen)
  );
  public readonly loading: Observable<boolean> = this.calendarState.pipe(
    map(s => s.loading)
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public formatTime(date: Date): string {
    return (
      momentTz(date)
        .tz(DEFAULT_TIMEZONE)
        .format('h:mm A') + ' ET'
    );
  }
}
